<template>
  <div>
    <el-card class="mb16">
      <template #header>
        <h4>{{$t('激活码详情')}}</h4>
      </template>
      <table-list :show-page="false" :data="[rowDetail]">
        <el-table-column align="center" :label="$t('激活码名称')" prop="name"/>
        <el-table-column align="center" :label="$t('开始时间')">
          <template v-slot="{row}">
            {{ row.startTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('结束时间')">
          <template v-slot="{row}">
            {{ row.endTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('品牌名称')" prop="brandName"/>
        <el-table-column align="center" :label="$t('品牌图片')">
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.brandPhoto"/>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('会员类型')">
          <template v-slot="{row}">
            <dict-text dict-flag="VIP_TYPE" :status="row.vipType"/>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('激活会员期限/月')" prop="convertNumber"/>
        <el-table-column align="center" :label="$t('生成数量')" prop="createCount"/>
        <el-table-column align="center" :label="$t('发放数量')">
          <template v-slot="{row}">
            {{ row.createCount * row.activateCount }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('已激活次数')" prop="alreadyActCount"/>
        <el-table-column align="center" :label="$t('激活次数上限')" prop="activateCount"/>
        <el-table-column align="center" :label="$t('发布时间')">
          <template v-slot="{row}">
            {{ row.releaseTime | formatDate }}
          </template>
        </el-table-column>
      </table-list>
    </el-card>

    <el-card>
      <template #header>
        <h4>{{$t('激活码明细')}}</h4>
      </template>

      <el-form size="small" inline>
        <el-form-item :label="$t('激活码')">
          <el-input v-model="searchForm.activateCode" :placeholder="$t('激活码')"/>
        </el-form-item>
        <el-form-item :label="$t('激活者会员编号')">
          <el-input v-model="searchForm.userNum" :placeholder="$t('激活者会员编号')"/>
        </el-form-item>
        <el-form-item label="激活者昵称">
          <el-input v-model="searchForm.username" :placeholder="$t('激活者昵称')"/>
        </el-form-item>
        <el-form-item :label="$t('是否激活')">
          <el-select v-model="searchForm.isActivate" clearable>
            <el-option :label="$t('是')" value="yes"/>
            <el-option :label="$t('否')" value="no"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('激活时间')">
          <el-date-picker
              v-model="searchForm.strartTime"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('选择日期时间')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
          <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
        </el-form-item>
      </el-form>

      <div class="flex-end mb16">
        <el-button type="danger" size="small" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
        <el-button type="danger" size="small" @click="handleBatchUpdateStatus('close')">{{$t('批量禁用')}}</el-button>
        <el-button type="primary" size="small" @click="handleBatchUpdateStatus('open')">{{$t('批量启用')}}</el-button>
        <el-button type="primary" size="small" @click="handleExport">{{$t('导出')}}</el-button>
      </div>

      <table-list
          ref="list"
          :data="tableData"
          @query="loadCodeList"
          :request-params="{actCode: $route.query.code}"
          :search-params="searchForm"
          @selection-change="selection = $event">
        <el-table-column align="center" type="selection" width="50"/>
        <el-table-column align="center" type="index" :label="$t('序号')" width="50"/>
        <el-table-column align="center" :label="$t('激活码')" prop="activateCode"/>
        <el-table-column align="center" :label="$t('激活者会员编号')" prop="userNum"/>
        <el-table-column align="center" :label="$t('激活者昵称')" prop="username"/>
        <el-table-column align="center" :label="$t('是否激活')">
          <template v-slot="{row}">
            {{ row.isActivate === "yes" ? $t('是') : $t('否') }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('激活次数')" prop="activateCount"/>
        <el-table-column align="center" :label="$t('激活时间')">
          <template v-slot="{row}">
            {{ row.startTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('激活到期时间')">
          <template v-slot="{row}">
            {{ row.endTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="ACTIVE_CODE_STATUS"/>
          </template>
        </el-table-column>


        <el-table-column align="center" :label="$t('操作')" width="130">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="$router.push('statusList')">{{$t('查看')}}</el-link>
              <el-link :underline="false" type="primary" @click="handleChangeStatus(row)" v-if="row.isActivate !== 'yes'">
                {{ row.status === "open" ? $t('禁用') : $t('启用') }}
              </el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </el-card>
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DictText from "@/components/dict/DictText";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "ActiveCodeDetail",
  components: {PreviewImg, DictText, TableList},
  data() {
    return {
      tableData: [],
      searchForm: {},
      selection: [],

      rowDetail: {}
    }
  },
  methods: {
    // 启用/禁用
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "close" : "open",
        }
        await request(this.$api.activateCodeRecord.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 批量禁用/启用
    async handleBatchUpdateStatus(status) {
      try {
        let params = this.selection.map(item => {
          return {
            code: item.code,
            status,
          }
        });
        if (!params.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }

        await request(this.$api.activateCodeRecord.batchUpdateStatus, params, {isJson: true});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },


    async handleDelete(row) {
      try {
        await requestByTip(this.$api.activateCodeRecord.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.activateCodeRecord.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    // 加载明细列表
    async loadCodeList(params, setTotal) {
      try {
        const res = await request(this.$api.activateCodeRecord.list, params);
        this.tableData = res.activateCodeRecords;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    },

    // 加载详情
    async loadDetail() {
      try {
        const res = await request(this.$api.activateCode.detail, this.$route.query);
        this.rowDetail = res.activateCode;
      } catch (e) {
        console.log(e);
      }
    },
    handleExport() {
      // console.log(this.selection);
      const codes = this.selection.map(item => item.code);
      console.log(codes)
      console.log(this.$route.query);
      const params = {
        actCode: this.$route.query.code,
        codes: codes
      }
      exportExcel(params, this.$api.activateCodeRecord.export);
    }
  },
  created() {
    this.loadDetail();
  }

}
</script>

<style scoped>

</style>
